import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import { Link } from "react-router-dom";
import Table, {
  TableHead,
  TableBody,
  TableCell,
  TableRow,
} from "material-ui/Table";
import {
  SalesforceJobState,
  SalesforceExportType,
} from "../../../../constants/ComponentTypes";
import { SALESFORCE_SYNC_HISTORIES_PER_PAGE } from "../../../../constants/Constants.js";
import Pagination from "../../../common/Pagination";
import * as moment from "moment";

const styles = () => ({
  table: {
    width: "100%",
    marginBottom: "20px",
  },

  tableHead: {
    background: "#f2f3f3",
  },

  tableHeadCell: {
    padding: "24px 12px",
    color: "#181819",
    fontWeight: "bold",
    fontSize: "13px",
  },

  tableCell: {
    padding: "15px 12px",
    color: "#181819",
    fontSize: "12px",
  },

  empty: {
    width: "100%",
    padding: "24px 5px",
    fontSize: "13px",
    color: "#5A5B62",
  },

  link: {
    color: "#1A65FF",
    textDecoration: "underline",
  },
});

class SalesforceSyncHistoryTable extends React.Component {
  displayJobState = (state) => {
    let text = "-";
    let jobState = Object.values(SalesforceJobState).find(
      (item) => item.value === state
    );

    if (jobState) {
      text = jobState.text;
    }
    return text;
  };

  displayExportType = (type) => {
    let text = "-";

    let exportType = Object.values(SalesforceExportType).find(
      (item) => item.value === type
    );

    if (exportType) {
      text = exportType.text;
    }

    return text;
  };

  displayExportObjects = (item) => {
    const { isImport } = this.props;

    if (isImport) {
      return item.sobject_name;
    }

    if (item && item.salesforce_jobs) {
      if (item.salesforce_jobs.length > 0) {
        return item.salesforce_jobs.map((job, i) => <div key={i}>{job.sobject_name}</div>);
      } else {
        let exportType = Object.values(SalesforceExportType).find(
          (type) => type.value === item.type
        );
        if (exportType) {
          return exportType.sobject
        }
      }
    }
    return "-";
  };

  calcRecordCount = (item) => {
    const { isImport } = this.props;
    let count = 0;

    if (isImport) {
      let detail = item.detail ? JSON.parse(item.detail) : null;
      if (detail && detail.hasOwnProperty("total_count")) {
        count = detail["total_count"];
      }
    } else {
      if (item && item.salesforce_jobs.length > 0) {
        count = item.salesforce_jobs.reduce((sum, curr) => {
          if (
            curr &&
            curr.hasOwnProperty("num_processed") &&
            !isNaN(curr["num_processed"])
          ) {
            return sum + curr.num_processed;
          } else {
            return sum;
          }
        }, 0);
      } else {
        let detail = item.detail ? JSON.parse(item.detail) : null;
        if (detail && detail.hasOwnProperty("total_num_processed")) {
          count = detail["total_num_processed"];
        }
      }
    }
    return count;
  };

  renderRow = (item, key) => {
    const { classes, isImport } = this.props;

    return (
      <TableRow key={key}>
        <TableCell className={classes.tableCell}>
          <Link
            to={
              isImport
                ? `/setting/integrations/salesforce/import-history/${item.id}`
                : `/setting/integrations/salesforce/export-history/${item.id}`
            }
            className={classes.link}
          >
            {item.id}
          </Link>
        </TableCell>

        {!isImport && (
          <TableCell className={classes.tableCell}>
            {this.displayExportType(item.type)}
          </TableCell>
        )}

        <TableCell className={classes.tableCell}>
          {isImport
            ? item.sobject_name
            : this.displayExportObjects(item)}
        </TableCell>

        <TableCell className={classes.tableCell}>
          {this.displayJobState(item.state)}
        </TableCell>

        <TableCell className={classes.tableCell}>
          {item.instructed_at
            ? moment(item.instructed_at).format("YYYY-MM-DD HH:mm:ss")
            : "-"}
        </TableCell>

        <TableCell className={classes.tableCell}>
          {item.finish_at
            ? moment(item.finish_at).format("YYYY-MM-DD HH:mm:ss")
            : "-"}
        </TableCell>
        <TableCell className={classes.tableCell}>
          {this.calcRecordCount(item)}
        </TableCell>
      </TableRow>
    );
  };
  render() {
    const { classes, items, pageInfo, isImport } = this.props;

    if (pageInfo && pageInfo.total > 0) {
      return (
        <div>
          <Table className={classes.table}>
            <TableHead className={classes.tableHead}>
              <TableRow>
                <TableCell className={classes.tableHeadCell}>Job Id</TableCell>
                {!isImport && (
                  <TableCell className={classes.tableHeadCell}>
                    ジョブタイプ
                  </TableCell>
                )}
                <TableCell className={classes.tableHeadCell}>
                  オブジェクト
                </TableCell>
                <TableCell className={classes.tableHeadCell}>
                  ステータス
                </TableCell>
                <TableCell className={classes.tableHeadCell}>開始時刻</TableCell>
                <TableCell className={classes.tableHeadCell}>終了時刻</TableCell>
                <TableCell className={classes.tableHeadCell}>
                  処理済みレコード数
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map((item, i) => this.renderRow(item, i))}
            </TableBody>
          </Table>
          {pageInfo && (
            <div className={classes.paginationContainer}>
              <Pagination
                currentPage={pageInfo.current_page}
                lastPage={pageInfo.last_page}
                total={pageInfo.total}
                perPage={SALESFORCE_SYNC_HISTORIES_PER_PAGE}
                showLastPage={true}
                disabled={this.props.isLoading}
                onChange={(data) =>
                  this.props.getHistories({ ...data, paging: 1 })
                }
              />
            </div>
          )}
        </div>
      );
    }
    return (
      <div className={classes.empty}>
        {isImport ? "インポート" : "エクスポート"}履歴がありません。
      </div>
    );
  }
}

SalesforceSyncHistoryTable.propTypes = {
  classes: PropTypes.object.isRequired,
  items: PropTypes.array.isRequired,
  pageInfo: PropTypes.object,
  isLoading: PropTypes.bool,
  getHistories: PropTypes.func,
  isImport: PropTypes.bool,
};

export default withStyles(styles)(SalesforceSyncHistoryTable);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/common/SalesforceSyncHistoryTable.jsx